import React, { useState, useEffect } from 'react';
import { FaShareAlt } from 'react-icons/fa';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ShareProfileModal from './ShareProfileModal';

const ShareOrganizationLink = ({ organizationId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [organization, setOrganization] = useState({
    id: organizationId,
    fullName: '',
    photoURL: '',
    expertise: [],
    profileType: 'organization'  // Add profileType to identify organization profiles
  });

  // Fetch organization data when modal opens
  useEffect(() => {
    const fetchOrgData = async () => {
      if (!isModalOpen) return;
      
      try {
        const orgDoc = await getDoc(doc(db, 'organizations', organizationId));
        if (orgDoc.exists()) {
          const orgData = orgDoc.data();
          setOrganization({
            id: organizationId,
            fullName: orgData.orgName || 'Organization',
            photoURL: orgData.logoUrl || '',
            expertise: orgData.services ? [orgData.services[0]] : [],
            profileType: 'organization'  // Ensure profileType is set
          });
        }
      } catch (error) {
        console.error('Error fetching organization data:', error);
      }
    };

    fetchOrgData();
  }, [isModalOpen, organizationId]);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="text-gray-600 hover:text-blue-600 transition-colors"
        title="Share profile"
      >
        <FaShareAlt className="h-5 w-5" />
      </button>

      <ShareProfileModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        profile={organization} 
      />
    </>
  );
};

export default ShareOrganizationLink;
